/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorfallbacktitle2Inputs */



/**
* | output |
* | --- |
* | "Something went wrong..." |
*
* @param {Errorfallbacktitle2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const errorfallbacktitle2 = /** @type {((inputs?: Errorfallbacktitle2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorfallbacktitle2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Something\nwent wrong...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algo\nsalió mal...")
	return /** @type {LocalizedString} */ ("Что-то пошло\nне так...")
});
export { errorfallbacktitle2 as "errorFallbackTitle" }